export default __webpack_public_path__ + "static/media/Quicksand-VariableFont_wght.cf52df73.ttf";